import { render, staticRenderFns } from "./PhoenixHiddenBanner.vue?vue&type=template&id=fce75300"
import script from "./PhoenixHiddenBanner.vue?vue&type=script&lang=js"
export * from "./PhoenixHiddenBanner.vue?vue&type=script&lang=js"
import style0 from "./PhoenixHiddenBanner.vue?vue&type=style&index=0&id=fce75300&prod&module=%24s&lang=scss"




function injectStyles (context) {
  
  this["$s"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports